import { useNavigate } from '@tanstack/react-router';
import { t } from '../../shared/i18n/index.js';
import { PageHeader } from '../../shared/ui/PageHeader.js';
import { usePermission } from '../../features/auth/model/usePermission.js';
import { AcceptQueue } from '../../features/requisition/ui/AcceptQueue.js';
import { AnalyticsSection } from '../../features/dashboard/ui/AnalyticsSection.js';
import { MyWorkSection } from '../../features/dashboard/ui/MyWorkSection.js';

/**
 * Smena boshidagi ekran.
 *
 * Hisobot ruxsati borlarga butun tahlil bo'limi ochiladi. Ruxsatsiz
 * xodimga tahlil bloklari umuman chizilmaydi — ular 403 bilan qaytardi
 * va ekran to'la qizil xatoga aylanardi.
 *
 * «Mening navbatim» KARTOCHKASI olib tashlandi: uning ostidagi qabul
 * navbatining O'ZI ayni sonni ham, satrlarni ham ko'rsatadi va
 * kartochka faqat amalga olib bormaydigan takroriy raqam edi. Backend
 * holati va sessiya kartochkalari ham shu sabab bilan olib tashlangan.
 */
export interface DashboardPageProps {
  /** Talabnoma sahifasiga o'tish — sahifa marshrutlashni bilmaydi. */
  onOpenRequisition?: (requisitionId: string) => void;
  /** «Berish» sahifasiga o'tish. */
  onOpenHandover?: () => void;
  /** Buxgalteriya bo'limiga o'tish. */
  onOpenSurveys?: () => void;
}

export const DashboardPage = ({
  onOpenRequisition,
  onOpenHandover,
  onOpenSurveys,
}: DashboardPageProps = {}) => {
  const { canAnywhere } = usePermission();

  return (
    <div className="flex flex-col gap-5">
      <PageHeader title={t('dashboard.title')} description={t('dashboard.subtitle')} />

      {/*
        «MENING ISHIM» — eng tepada va tahlildan OLDIN.

        Tahlil butun mintaqaning yig'ma raqamlari: rahbarga kerakli,
        skladchiga esa begona. Smena boshida ekranni ochgan odam avval
        O'Z ishini ko'rishi kerak — «bugun nima qilaman?» degan savolga
        javob boshqa bo'limda yotmasin.
      */}
      <MyWorkSection
        {...(onOpenHandover === undefined ? {} : { onOpenHandover })}
        {...(onOpenSurveys === undefined ? {} : { onOpenSurveys })}
      />

      {canAnywhere('report.view') ? (
        <AnalyticsSection
          {...(onOpenRequisition === undefined ? {} : { onOpenRequisition })}
        />
      ) : null}

      {/*
        QABUL QILISH — `/inbox` dagi AYNI komponent.
        Mahsulotni olib kelishganda odam ko'pincha smena boshidagi shu
        ekranda turadi va amal uchun «Mening navbatim» sahifasiga
        o'tishi shart emas.
      */}
      <AcceptQueue onOpenRequisition={(id) => onOpenRequisition?.(id)} />
    </div>
  );
};

/**
 * Marshrutga ulanadigan o'ram — `InboxRoute` bilan bir uslub.
 *
 * Navigatsiya SAHIFADAN tashqarida qoladi: shunda sahifaning o'zi
 * routersiz ham chizilaveradi va sinaladi.
 */
/** Bo'lim yo'llari — `NAV_ITEMS` dagi bilan bir xil satrlar. */
const HANDOVER_PATH: string = '/handover';
const SURVEYS_PATH: string = '/accounting/surveys';

export const DashboardRoute = () => {
  const navigate = useNavigate();
  return (
    <DashboardPage
      onOpenRequisition={(id) =>
        void navigate({ to: '/requisitions/$requisitionId', params: { requisitionId: id } })
      }
      /* Yo'l SATR bo'lib uzatiladi (`AppShell` dagi `go` bilan ayni
         naqsh): bo'lim marshrutlari `NAV_ITEMS` dan quriladi va ularning
         literal turlari marshrut daraxtida yo'q. */
      onOpenHandover={() => void navigate({ to: HANDOVER_PATH })}
      onOpenSurveys={() => void navigate({ to: SURVEYS_PATH })}
    />
  );
};
